import { MdEdit, MdDelete } from "react-icons/md";
import "./index.css";

const TransactionItem = ({
  txn,
  categories,
  onEdit,
  onDelete
}) => {

  const match = categories.find(c => c.name === txn.category);
  const Icon = match?.icon;

  return (
    <div className="txn-item">

      <div className="txn-item-icon-block">
        {Icon && <Icon size={22} />}
      </div>

      <div className="txn-info">
        <h4>{txn.title}</h4>
        <p>{txn.notes}</p>
      </div>

      <div className="txn-right">
        <span className="txn-amount">
          -₹{Number(txn.amount).toFixed(2)}
        </span>

        <button onClick={() => onEdit(txn)}>
          <MdEdit />
        </button>

        <button onClick={() => onDelete(txn.id)}>
          <MdDelete />
        </button>
      </div>

    </div>
  );
};

export default TransactionItem;
